import type { BundleCreateDto, BundleDto, BundleUpdateDto, BundleWithNavigationPropertiesDto, GetBundlesInput } from './models';
import { RestService } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import type { LookupDto, LookupRequestDto } from '../shared/models';

@Injectable({
  providedIn: 'root',
})
export class BundleService {
  apiName = 'Default';
  

  create = (input: BundleCreateDto) =>
    this.restService.request<any, BundleDto>({
      method: 'POST',
      url: '/api/app/bundles',
      body: input,
    },
    { apiName: this.apiName });
  

  delete = (id: string) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/app/bundles/${id}`,
    },
    { apiName: this.apiName });
  

  get = (id: string) =>
    this.restService.request<any, BundleDto>({
      method: 'GET',
      url: `/api/app/bundles/${id}`,
    },
    { apiName: this.apiName });
  

  getList = (input: GetBundlesInput) =>
    this.restService.request<any, PagedResultDto<BundleWithNavigationPropertiesDto>>({
      method: 'GET',
      url: '/api/app/bundles',
      params: { filterText: input.filterText, title: input.title, description: input.description, tenantDocumentId: input.tenantDocumentId, tenantCourseId: input.tenantCourseId, testId: input.testId, ticketId: input.ticketId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName });
  

  getTenantCourseLookup = (input: LookupRequestDto) =>
    this.restService.request<any, PagedResultDto<LookupDto<string>>>({
      method: 'GET',
      url: '/api/app/bundles/tenant-course-lookup',
      params: { filter: input.filter, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName });
  

  getTenantDocumentLookup = (input: LookupRequestDto) =>
    this.restService.request<any, PagedResultDto<LookupDto<string>>>({
      method: 'GET',
      url: '/api/app/bundles/tenant-document-lookup',
      params: { filter: input.filter, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName });
  

  getTestLookup = (input: LookupRequestDto) =>
    this.restService.request<any, PagedResultDto<LookupDto<string>>>({
      method: 'GET',
      url: '/api/app/bundles/test-lookup',
      params: { filter: input.filter, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName });
  

  getTicketLookup = (input: LookupRequestDto) =>
    this.restService.request<any, PagedResultDto<LookupDto<string>>>({
      method: 'GET',
      url: '/api/app/bundles/ticket-lookup',
      params: { filter: input.filter, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName });
  

  getWithNavigationProperties = (id: string) =>
    this.restService.request<any, BundleWithNavigationPropertiesDto>({
      method: 'GET',
      url: `/api/app/bundles/with-navigation-properties/${id}`,
    },
    { apiName: this.apiName });
  

  update = (id: string, input: BundleUpdateDto) =>
    this.restService.request<any, BundleDto>({
      method: 'PUT',
      url: `/api/app/bundles/${id}`,
      body: input,
    },
    { apiName: this.apiName });

  constructor(private restService: RestService) {}
}
